import React from 'react'

const Logo = () => {
  return (
    <img
      src="./assets/Web_logo.png"
      alt="web_logo"
      width="170px"
      height="40px"
    />
  )
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/logo/index.js